<div class="vessel-dropdown" [class.disabledOption]="!canCreateOrDelete">
    <h3 class="vessel-title main-title">
        {{ 'editor.navigation.tab.library' | translate }}
        <mat-icon class="title-arrow" svgIcon="dropdown-arrow"></mat-icon>
    </h3>
    <div class="vessel-title-options">
        <div
            class="create-mimic-button"
            data-cy="mimics-create-library-button"
            (click)="createLibrary()"
            [class.disabledOption]="!canCreateOrDelete">
            {{ 'editor.navigation.create-library.button' | translate }}
        </div>
    </div>
</div>
<div class="vessel-list-container">
    <div
        class="vessel-list"
        [class.disabledOption]="!canCreateOrDelete"
        data-cy="mimics-library-list"
        #libraryListElement>
        <div class="library">
            <div class="library-item" (click)="toggleDefault(); $event.stopPropagation()">
                <mat-icon class="icon arrow" [class.open]="defaultExpanded" svgIcon="dropdown-arrow"></mat-icon>
                <mat-icon class="icon" svgIcon="mimic-default"></mat-icon>
                <div class="library-title">
                    {{ 'mimic.library.default' | translate }}
                </div>
            </div>
            <div class="category-list" *ngIf="defaultExpanded">
                <div
                    class="category"
                    *ngFor="let item of defaultItems"
                    [class.select]="selectedCategory?.id === 'default-' + item.name.toLowerCase()"
                    (click)="openDefaultComponentDialog(item.name); $event.stopPropagation()">
                    <mat-icon class="icon"></mat-icon>
                    <mat-icon class="icon" [svgIcon]="item.svgIcon"></mat-icon>
                    <div class="library-title">
                        {{ item.name | translate }}
                    </div>
                    <mat-icon svgIcon="dropdown-arrow" class="icon arrow"></mat-icon>
                </div>
            </div>
        </div>
        <div class="library" (click)="selectLibrary(library)" *ngFor="let library of libraryList; index as i">
            <div
                class="library-item"
                (click)="openOrCloseCategory(library.id, i, library.expanded); $event.stopPropagation()"
                [class.select]="selectedLibrary?.id === library.id && !selectedCategory?.id">
                <mat-icon class="icon arrow" [class.open]="library.expanded" svgIcon="dropdown-arrow"></mat-icon>
                <mat-icon class="icon" svgIcon="mimics"></mat-icon>
                <div class="library-title" data-cy="mimics-library-name">
                    {{ library.name }}
                </div>
                <mat-icon
                    svgIcon="more-options"
                    class="icon options-icon"
                    data-cy="mimics-library-kebab-icon"
                    (click)="openLibraryOptions(library, i); $event.stopPropagation()"></mat-icon>
                <ng-container *ngIf="showOption === library">
                    <div style="position: fixed; left: 365px; z-index: 1" [style.top.px]="dynamicHeight">
                        <div class="more-options-container">
                            <div
                                class="button new-option"
                                data-cy="mimics-library-kebab-menu-create-category"
                                [class.disabledOption]="!canCreateOrDelete"
                                (click)="createCategory(library); $event.stopPropagation()">
                                <mat-icon svgIcon="plus" class="icon" />
                                {{ 'editor.navigation.create-category.button' | translate }}
                            </div>
                            <div
                                class="button"
                                data-cy="mimics-library-kebab-menu-delete-library"
                                [class.disabledOption]="!canCreateOrDelete"
                                (click)="deleteLibrary(library); $event.stopPropagation()">
                                <mat-icon svgIcon="delete" class="icon" />
                                {{ 'mimic.page.button.delete' | translate }}
                            </div>
                            <div
                                class="button"
                                data-cy="mimics-library-kebab-menu-edit-library"
                                [class.disabledOption]="!canCreateOrDelete"
                                (click)="editLibrary(library); $event.stopPropagation()">
                                <mat-icon svgIcon="edit-pen" class="icon" />
                                {{ 'mimic.page.button.edit' | translate }}
                            </div>
                            <div
                                class="button"
                                data-cy="mimics-library-kebab-menu-duplicate-library"
                                (click)="duplicateLibrary(library); $event.stopPropagation()"
                                [class.disabledOption]="!canCreateOrDelete">
                                <mat-icon svgIcon="duplicate" class="icon" />
                                {{ 'mimic.page.button.duplicate' | translate }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="category-list" data-cy="mimics-library-category-list" *ngIf="library.expanded">
                <div
                    class="category"
                    *ngFor="let category of library?.libraryCategories"
                    [class.select]="selectedCategory?.id === category.id"
                    (contextmenu)="openCategoryOptions(category, $event)"
                    (click)="openComponentDialog(category); $event.stopPropagation()">
                    <mat-icon class="icon arrow"></mat-icon>
                    <mat-icon class="icon"></mat-icon>
                    <div class="library-title" data-cy="mimics-library-category-name">
                        {{ category.name }}
                    </div>
                    <mat-icon svgIcon="dropdown-arrow" class="icon arrow"></mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
